export default __webpack_public_path__ + "static/media/loading.4c3b78e2.svg";